import { debounce } from 'lodash-es';
import { useEmptyModal } from './empty';
import Resource from '~/components/resource';
import AiMark from '~/components/ai-mark/index.vue';

export const useVideoView = debounce((url: string, trackParams?: any) => {
  if (!url) {
    return;
  }

  const { $t } = useNuxtApp();

  const suffix = url.split('?')?.[0].split('.').pop()?.toLowerCase();
  if (['mov', 'mkv'].includes(suffix || '')) {
    message.warning(
      $t('liu-lan-qi-zan-bu-zhi-chi-ci-ge-shi-shi-pin-bo-fang-qing-xia-zai-cheng-pian-hou-cha-kan'),
    );
    return;
  }
  if (trackParams) {
    trackEvent(TRACK_EVENT.CLICK_PLAY_VIDEO, trackParams);
  }

  return useEmptyModal({
    closable: true,
    maskClosable: true,
    width: '68vw',
    content: (
      <div class="relative w-full h-0 pb-[56.25%] bg-black rounded-[12px]">
        <AiMark theme="video" class="absolute top-[16px] right-[16px] z-20" />
        <video
          class="absolute top-0 left-0 w-full h-full block rounded-[12px] bg-black"
          autoplay
          controls={true}
          src={url}
        />
      </div>
    ),
  });
}, 200);

export const useImgView = debounce((url: string, trackParams?: any) => {
  return useEmptyModal({
    closable: true,
    maskClosable: true,
    width: 'auto',
    wrapClassName: 'xmov-empty-modal image-preview-modal',
    bodyStyle: {
      'max-width': '1000px',
    },
    content: (
      <div class="w-full flex-center">
        <Resource
          class="max-w-full max-h-full block rounded-[12px]"
          src={url}
          transformResource={transformImage}
        />
      </div>
    ),
  });
}, 200);

export const useImgsView = debounce((list: string[], trackParams?: any) => {
  return useEmptyModal({
    closable: true,
    maskClosable: true,
    width: '60vw',
    content: (
      <div class="w-full h-[88vh] p-[10px] overflow-y-auto overflow-x-hidden">
        {list.map(url => (
          <Resource
            class="w-full max-w-full block mb-[10px] rounded-[10px] border-[1px] border-[#efefef] border-solid"
            src={url}
            transformResource={transformImage}
          />
        ))}
      </div>
    ),
  });
}, 200);
